export default "__VITE_ASSET__Dwe53yFV__$_?component__"